import React, { Component, createContext } from "react";

export const UserContext = createContext();

export class UserProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      importedListings: [], // Save user imported items
      pushedListings: [], // Save user pushed items
      downgradeAttemptId: "", // passed id from previous downgrade event to tie the funnel
      showCornerUpgradeButton: false, // save information if upgrade button is shown
      bulkImportInProcess: false, // save information if bulk import process is happening
      userHasSeenShopifyModal: false, // save information if user has seen connect store shopify modal on /search
      lastSeenProductId: "", // save information about the last product seen before a plan upgrade, for example
      lastSelectedPaymentMethod: "chargebee_payment" // save selected payment method information to use on Annual Promotion modal
    };
  }

  setStoreInfo = (attribute, value) => {
    this.setState({ [attribute]: value });
  };

  render() {
    return (
      <UserContext.Provider
        value={{
          ...this.state,
          setStoreInfo: this.setStoreInfo
        }}
      >
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

// Left this here if we eventually need in the future
export const withUserContext = Component => props => (
  <UserContext.Consumer>{state => <Component {...props} context={state} />}</UserContext.Consumer>
);
